import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const authManagementApi = createApi({
	reducerPath: "authManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["auth-api"],
	}),
	endpoints: (builder) => ({
		reAuth: builder.mutation({
			query: (usernameParam) => {
				const user = getUser();
				const username = (usernameParam || user?.username || "").toLowerCase();

				return {
					url: "/re-auth",
					method: "POST",
					body: { username },
				};
			},
		}),
	}),
});

export const { useReAuthMutation } = authManagementApi;
